import { render, staticRenderFns } from "./LFTabs.vue?vue&type=template&id=3e169374&"
import script from "./LFTabs.vue?vue&type=script&lang=js&"
export * from "./LFTabs.vue?vue&type=script&lang=js&"
import style0 from "./LFTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports